import { EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';
import { gspx } from '@rsos/gainsight';

export const trackAlertMarkerClicks = (activeQueueTab, irpVersion, alertID) => {
  let displayTab = activeQueueTab;
  if (activeQueueTab === EMERGENCY_CALLS) {
    displayTab = '911 call';
  }
  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click Alert marker when ${displayTab} tab is active`,
    Category: 'Alert',
    AlertID: alertID,
    'Launched date': new Date(),
  });
};

export const trackCallMarkerClicks = (activeQueueTab, irpVersion) => {
  let displayTab = activeQueueTab;
  if (activeQueueTab === EMERGENCY_CALLS) {
    displayTab = '911 call';
  }
  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click 911 call marker when ${displayTab} tab is active`,
    Category: 'Alert',
    'Launched date': new Date(),
  });
};

export const trackCloseAlertPane = (selectedAlertID, irpVersion) => {
  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click x to close the alert event pane`,
    Category: 'Alert',
    'Launched date': new Date(),
    AlertID: selectedAlertID,
  });
};

export const trackClickTab = (tabName, irpVersion) => {
  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click ${tabName} tab`,
    Category: 'Alert',
    'Launched date': new Date(),
  });
};

export const trackHoverOn = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: 'Calls Hovered On',
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    isSXMCrashed: isConnectedCar,
    payloadID,
    requestID,
    portalType,
    serviceType,
    classOfServices,
    callStatus: callStatus || '',
  });
};

export const trackHoverOnCall = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: 'Hover on a call from the call queue in Jurisdiction View',
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    isSXMCrashed: isConnectedCar,
    payloadID,
    requestID,
    portalType,
    serviceType,
    classOfServices,
    callStatus: callStatus || '',
  });
};

export const trackHoverOnPin = (
  irpVersion,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    serviceType,
    classOfServices,
    callStatus: callStatus || '',
    name: 'Hover on a pin',
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
  });
};

export const trackClickOnCallFromMap = irpVersion => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: `Click on Call From Map`,
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
  });
};

export const trackHoverOnCallWithTime = (
  time,
  hoveredFrom,
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: `Hover more than ${time} second for a call on the ${hoveredFrom}`,
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    isSXMCrashed: isConnectedCar,
    payloadID,
    requestID,
    portalType,
    serviceType,
    classOfServices,
    callStatus: callStatus || '',
  });
};

export const trackCloseRADECard = (irpVersion, portalType) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    portalType,
    name: `Click x to close additional data card`,
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
  });
};

export const trackScreenResolutionChange = (
  irpVersion,
  prevScreenResolution,
  currentScreenResolution,
  currentScreenHeight,
) => {
  const message =
    prevScreenResolution > currentScreenResolution ? 'lower' : 'higher';
  gspx.trackCustomEvent('Screen Resolution Adjustment', {
    irpVersion,
    name: `The screen width has been adjusted to the ${message} resolution`,
    Category: 'Responsive',
    'Launched date': new Date(),
  });
  gspx.trackCustomEvent('Screen Resolution Adjustment', {
    irpVersion,
    name: `The screen resolution: width is ${currentScreenResolution} and height is ${currentScreenHeight}`,
    Category: 'Responsive',
    'Launched date': new Date(),
  });
};
